import { VIEWS, type ViewId } from './liveDataAdapter';

const FILTER_KEYS = [
  'split',
  'margin',
  'product',
  'country',
  'channel',
  'detail',
  'chain',
  'vendor',
  'property',
  'action',
  'dmin',
  'dmax',
  'sdmin',
  'sdmax',
  'wchannel',
  'vmin',
  'vmax',
  'imin',
  'imax',
];
const VIEW_FILTERS: Record<ViewId, string[]> = {
  [VIEWS[0]]: ['split', 'product', 'country', 'chain', 'vendor', 'action'],
  [VIEWS[1]]: ['split', 'margin', 'country', 'channel', 'detail', 'chain', 'property', 'action'],
  // Recent Launches has its own days since launch range for the LPC and SPP sections (sdmin/sdmax is SPP).
  [VIEWS[2]]: ['country', 'chain', 'vendor', 'property', 'margin', 'dmin', 'dmax', 'sdmin', 'sdmax'],
  // Worst Performers has its own SPP channel filter, separate from the Overview SPP channel and detail pair.
  [VIEWS[3]]: ['country', 'vmin', 'vmax', 'wchannel', 'imin', 'imax'],
};

export function marketplaceFilterKeys(view: ViewId): string[] {
  return ['view', ...VIEW_FILTERS[view]];
}

/** A worksheet can only carry filters its controls expose. Unrelated URL state is retained. */
export function marketplaceViewParams(current: URLSearchParams, view: ViewId): URLSearchParams {
  const next = new URLSearchParams(current);
  FILTER_KEYS.forEach((key) => {
    if (!VIEW_FILTERS[view].includes(key)) next.delete(key);
  });
  return next;
}

export function updateMarketplaceFilters(
  current: URLSearchParams,
  changes: Record<string, string | null>,
  view: ViewId,
): URLSearchParams {
  const next = new URLSearchParams(current);
  Object.entries(changes).forEach(([key, value]) => {
    if (value === null || value === '') next.delete(key);
    else next.set(key, value);
  });
  // A detail belongs to its channel. Never retain a stale child after its parent changes.
  if ('channel' in changes && !('detail' in changes)) next.delete('detail');
  if ('view' in changes) next.delete('action');
  return marketplaceViewParams(next, view);
}

export function resetMarketplaceFilters(current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current);
  FILTER_KEYS.forEach((key) => next.delete(key));
  return next;
}
